import { REQUIRED_PLACEHOLDER_SYMBOL } from '@/shared/config';

export function getRequiredLabel(
  label?: string,
  required: boolean = true
): string {
  let inputLabel = label;

  if (inputLabel && required) {
    inputLabel = `${inputLabel} ${REQUIRED_PLACEHOLDER_SYMBOL}`;
  }

  return inputLabel || '';
}
